import { render, staticRenderFns } from "./CompanySetting.vue?vue&type=template&id=3b874b1b&scoped=true"
import script from "./CompanySetting.vue?vue&type=script&lang=js"
export * from "./CompanySetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b874b1b",
  null
  
)

export default component.exports